import { Box, Button, LoaderNew, Text } from '@jfs/ui-new'

export const RenderActionButtons = ({
  buttonRef,
  isEditScreen,
  previousFormData,
  mid,
  jfsUserId,
  screenName,
  borderTopColor,
  isCurrentFormValid,
  addEmailEnabled = false,
  navigation,
  isLoading,
  onSubmitPress,
}: any) => {
  const isAllSelected = () => {
    const { email, mobile, role, userName } = buttonRef?.current?.values ?? {}
    if (isEditScreen) {
      return role !== ''
    } else if (mobile && role && userName) {
      if (addEmailEnabled) {
        return isCurrentFormValid
      } else {
        return true
      }
    } else {
      return false
    }
  }

  const enableBtn = isAllSelected()

  // console.log('buttonRef?.current?.isValid', buttonRef?.current?.values, buttonRef?.current, isCurrentFormValid)
  // console.log('enableBtn', enableBtn)
  return (
    <Box borderTopWidth={1} borderTopColor={borderTopColor ?? 'BORDER_COLOR'} justifyContent="center">
      <Button
        disabled={!enableBtn || isLoading}
        isFull
        isRound
        testID="btn-user-mng"
        onPress={onSubmitPress}
        height={48}>
        {isLoading ? (
          <LoaderNew type={'small'} color="WHITE" />
        ) : (
          <Text color="WHITE" fontSize={16} fontFamily="JioType-Bold">
            {isEditScreen ? 'Save Changes' : 'Add User'}
          </Text>
        )}
      </Button>
    </Box>
  )
}
